import request from '@/utils/request';

/* eslint-disable */
const actions = {
  async getFilters({ dispatch, commit, getters }, { uuid, params = {} }) {
    try {
      await commit('updateIsLoading', { isLoading: true });

      const { data } = await request.get(`filterGroups/${uuid}/filters`, {
        params,
      });

      if (data.error) {
        throw Error('Server-side validation failed');
      }

      await commit('setData', data.filters);

      await commit('updateIsLoading', { isLoading: false });
    } catch (err) {
      await commit('updateIsLoading', { isLoading: false });

      throw err;
    }
  },
};

export default actions;
